import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule, ButtonSeverity } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';

/** Champ de saisie de l'assistant (Entrée = envoyer, Maj+Entrée = nouvelle ligne). */
@Component({
    selector: 'app-assistant-composer',
    standalone: true,
    imports: [
        NgClass,
        FormsModule,
        ButtonModule,
        TextareaModule,
    ],
    templateUrl: './assistant-composer.component.html',
    styleUrl: './assistant-composer.component.scss',
})
export class AssistantComposerComponent {

    @Input() disabled: boolean = false;
    /** Invite du champ : ce qu'on attend d'y taper change avec le point d'entrée. */
    @Input() placeholder: string = 'Écrivez votre message…';
    /**
     * Sévérité du bouton d'envoi. `help` — rendu violet par Aura — est la
     * convention des éléments d'IHM liés à l'IA ; l'assistant du manuel s'en
     * sert pour se distinguer d'une recherche.
     */
    @Input() severity: ButtonSeverity = undefined;
    /** Teinte de la bordure du champ : plus claire là où l'hôte est sur fond blanc (panneau). */
    @Input() borderClass: string = 'border-500';
    @Output() send = new EventEmitter<string>();

    @ViewChild('input') private _input?: ElementRef<HTMLTextAreaElement>;

    draft: string = '';

    /** Donne le focus au champ (pour enchaîner après une réponse de l'agent). */
    public focus(): void {
        this._input?.nativeElement.focus();
    }

    public onKeydownEnter(event: Event): void {
        const keyboardEvent = event as KeyboardEvent;
        if (keyboardEvent.shiftKey) return;
        keyboardEvent.preventDefault();
        this._send();
    }

    public onSubmit(): void {
        this._send();
    }

    private _send(): void {
        const text = this.draft.trim();
        if (!text || this.disabled) return;
        this.draft = '';
        this.send.emit(text);
    }
}
